import type { ReactNode } from "react";

/** Renders the standard section eyebrow, heading, and optional supporting copy.
 * The heading is an `<h2>` by default; pages with no hero pass `as="h1"` so the
 * page still ships exactly one primary heading. */
export function SectionHead({
  eyebrow,
  heading,
  sub,
  reveal,
  as: Heading = "h2",
  className = "",
}: {
  eyebrow: ReactNode;
  heading: ReactNode;
  sub?: string;
  reveal?: boolean;
  as?: "h1" | "h2";
  className?: string;
}) {
  const r = reveal ? { "data-reveal": true } : {};
  return (
    <div className={`section-head ${className}`}>
      <span {...r} className="section-head__eyebrow eyebrow">
        {eyebrow}
      </span>
      <Heading {...r} className="section-head__title section-title">
        {heading}
      </Heading>
      {sub && (
        <p {...r} className="section-head__lede mt-4 lede">
          {sub}
        </p>
      )}
    </div>
  );
}
